export default __webpack_public_path__ + "images/6I.d522514.png";